module.exports = __webpack_public_path__ + "static/media/storeFront.35cc73cd.svg";